import {defineMessages} from 'react-intl';

export default defineMessages({
	firstLine: {
		id: 'customerCare.firstLine',
		defaultMessage:
			'<serviceText>Ask our Customer Service. </serviceText><ctaText>Please <cta>click here</cta>.</ctaText>',
	},
	secondLine: {
		id: 'customerCare.secondLine',
		defaultMessage: 'Customer care: <hours>10:00 am - 07:00 pm gmt + 2</hours>',
	},
});
